const systemconfig = {
    baseUrl: process.env.REACT_APP_BASE_URL,
  };
  
  export default systemconfig;
  